import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import React, { useState } from "react";
import { SideBar } from "../components/app/Sidebar";

const DashboardLayout = () => {
	const isSidebarOpen = localStorage.getItem('isSidebarOpen')
	const isMenuOpen = isSidebarOpen ? JSON.parse(isSidebarOpen) : true
	const [isOpen, setIsOpen] = useState<boolean>(isMenuOpen)

  return (
    <Box sx={{ 
      display: "flex", 
      height: "100vh", // Set full viewport height
      overflow: "hidden", // Prevent body scroll
    }}>
      {/* Fixed Sidebar on the left */}
      <Box sx={{ 
        position: "fixed", 
        left: 0, 
        top: 0, 
        height: "100vh", 
        zIndex: 1000,
        backgroundColor: "background.paper",
      }}>
        <SideBar isOpen={isOpen} setIsOpen={setIsOpen} />
      </Box>

      {/* Main content area with proper margins and scrolling */}
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          marginLeft: isOpen ? "180px" : "52px", // Adjust margin based on sidebar width
          height: "100vh", // Full viewport height
          overflow: "auto", // Enable scrolling for main content
          transition: "margin-left 0.2s ease", // Smooth transition when sidebar toggles
          backgroundColor: "#f8fafc", // Background color for main content
        }}
      >
        <Box sx={{ p: 3 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;

